import { render, staticRenderFns } from "./OrganizationCreateOrgInfo.vue?vue&type=template&id=080697c0&"
import script from "./OrganizationCreateOrgInfo.vue?vue&type=script&lang=ts&"
export * from "./OrganizationCreateOrgInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports